export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_02.9b74bb6c.jpg";